/* tslint:disable */
/* eslint-disable */
/**
 * Tag API
 * API for managing document tags
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateTagResponse interface.
 */
export function instanceOfUpdateTagResponse(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
export function UpdateTagResponseFromJSON(json) {
    return UpdateTagResponseFromJSONTyped(json, false);
}
export function UpdateTagResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
export function UpdateTagResponseToJSON(json) {
    return UpdateTagResponseToJSONTyped(json, false);
}
export function UpdateTagResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
    };
}
